// <filtered-reviews> with .filtered-reviews__tab[data-category] buttons and
// .review-card[data-category] cards. Filters cards on tab click.
class FilteredReviews extends HTMLElement {
  connectedCallback() {
    this.tabs = this.querySelectorAll('.filtered-reviews__tab');
    this.cards = this.querySelectorAll('.review-card');
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activate(tab.dataset.category));
    });
    // Apply the initial active filter
    const active = this.querySelector('.filtered-reviews__tab.is-active');
    if (active) this.filter(active.dataset.category);
  }

  activate(category) {
    this.tabs.forEach((tab) => {
      const on = tab.dataset.category === category;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    this.filter(category);
  }

  filter(category) {
    let lastVisible = null;
    this.cards.forEach((card) => {
      const hide = card.dataset.category !== category;
      card.hidden = hide;
      card.classList.remove('is-last-visible');
      if (!hide) lastVisible = card;
    });
    if (lastVisible) lastVisible.classList.add('is-last-visible');
  }
}

if (!customElements.get('filtered-reviews')) {
  customElements.define('filtered-reviews', FilteredReviews);
}
